module.exports = __webpack_public_path__ + "static/images/logo_photizo.899f00f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_photizo.png
// module id = +LNh
// module chunks = 1